import {
  computed, observable, makeObservable,
  makeAutoObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { GetLangKey } from '../utilities/general';
import { BLOG_CATEGORY } from '../constants/options';

export default class PublicStore {
  loading: boolean = false;
  loadingCPD: boolean = false;
  loadingEvent: boolean = false;
  loadingNews: boolean = false;
  loadingInfo: boolean = false;
  loadingTrainingCourse: boolean = false;

  openOnlinePaymentModal: boolean = false;

  loadingPublicDownloads: boolean = false;
  downloadingPublicDocument: boolean = false;
  publicDownloads: any[] = [];

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  searchCPD = async (skip: number, take: number, userModel: any) => {
    this.loadingCPD = true;
    try {
      const res = await Axios.post(`/api/Cpd/Search/${skip}/${take}`, { ...userModel, isPublished: true, cpdCategoryIds: [BLOG_CATEGORY.PUBLIC_CPD], language: GetLangKey() });
      console.log("CPD Search", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingCPD = false;
    }
  };

  searchEvent = async (skip: number, take: number, userModel: any) => {
    this.loadingEvent = true;
    try {
      const res = await Axios.post(`/api/Cpd/Search/${skip}/${take}`, { ...userModel, isPublished: true, cpdCategoryIds: [BLOG_CATEGORY.EVENT], language: GetLangKey() });
      console.log("Event Search", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingEvent = false;
    }
  };


  searchNews = async (skip: number, take: number, userModel: any) => {
    this.loadingNews = true;
    try {
      const res = await Axios.post(`/api/News/Search/${skip}/${take}`, { ...userModel, isPublished: true, cpdCategoryIds: [BLOG_CATEGORY.PUBLIC_CPD], language: GetLangKey() });
      console.log("News Search", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingNews = false;
    }
  };


  getNewsById = async (id: number) => {
    this.loadingInfo = true;
    try {
      const res = await Axios.get(`/api/News/${id}/${GetLangKey()}`);
      console.log("News Info", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingInfo = false;
    }
  };


  searchTrainingCourse = async (skip: number, take: number, userModel: any) => {
    this.loadingTrainingCourse = true;
    try {
      const res = await Axios.post(`/api/Cpd/Search/${skip}/${take}`, { ...userModel, isPublished: true, cpdCategoryIds: [BLOG_CATEGORY.TRAINING_COURSE], language: GetLangKey() });
      console.log("Training Course Search", res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingTrainingCourse = false;
    }
  };

  searchPublicDownloadFiles = async (skip: number, take: number, userModel: {
    chName?: string;
    enName?: string;
  }) => {
    this.loadingPublicDownloads = true;
    try {
      const res = await Axios.post(`/api/Download/Category/Search/${skip}/${take}`, { ...userModel });
      // console.log("Public Downloads Search", res.data);

      this.publicDownloads = res.data;
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loadingPublicDownloads = false;
    }
  }

  downloadPublicDocument = async (savedName: string) => {
    this.downloadingPublicDocument = true;
    try {
      const res = await Axios.get(`/api/Download/Attachment/${savedName}`, { responseType: 'blob' });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.downloadingPublicDocument = false;
    }
  }
}

